export const d2024 = {
  "item": [
    {
      "dateKind": "01",
      "dateName": "1월1일",
      "isHoliday": "Y",
      "locdate": 20240101,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240209,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240210,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240211,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일(설날)",
      "isHoliday": "Y",
      "locdate": 20240212,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "삼일절",
      "isHoliday": "Y",
      "locdate": 20240301,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "국회의원선거",
      "isHoliday": "Y",
      "locdate": 20240410,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "어린이날",
      "isHoliday": "Y",
      "locdate": 20240505,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일(어린이날)",
      "isHoliday": "Y",
      "locdate": 20240506,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "부처님오신날",
      "isHoliday": "Y",
      "locdate": 20240515,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "현충일",
      "isHoliday": "Y",
      "locdate": 20240606,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "광복절",
      "isHoliday": "Y",
      "locdate": 20240815,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240916,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240917,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240918,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "개천절",
      "isHoliday": "Y",
      "locdate": 20241003,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "한글날",
      "isHoliday": "Y",
      "locdate": 20241009,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "기독탄신일",
      "isHoliday": "Y",
      "locdate": 20241225,
      "seq": 1
    }
  ]
};

export const d2025 = {
  "item": [
    {
      "dateKind": "01",
      "dateName": "1월1일",
      "isHoliday": "Y",
      "locdate": 20250101,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250128,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250129,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250130,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "삼일절",
      "isHoliday": "Y",
      "locdate": 20250301,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20250303,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "어린이날",
      "isHoliday": "Y",
      "locdate": 20250505,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "부처님오신날",
      "isHoliday": "Y",
      "locdate": 20250505,
      "seq": 2
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20250506,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "현충일",
      "isHoliday": "Y",
      "locdate": 20250606,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "광복절",
      "isHoliday": "Y",
      "locdate": 20250815,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "개천절",
      "isHoliday": "Y",
      "locdate": 20251003,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251005,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251006,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251007,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20251008,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "한글날",
      "isHoliday": "Y",
      "locdate": 20251009,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "기독탄신일",
      "isHoliday": "Y",
      "locdate": 20251225,
      "seq": 1
    }
  ]
};

export const d2026 = {
  item: [
    // 1월
    {
      dateKind: "01",
      dateName: "신정",
      isHoliday: "Y",
      locdate: 20260101,
      seq: 1
    },

    // 2월 설날 연휴 (16~18일)
    {
      dateKind: "01",
      dateName: "설날",
      isHoliday: "Y",
      locdate: 20260216,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "설날",
      isHoliday: "Y",
      locdate: 20260217,
      seq: 2
    },
    {
      dateKind: "01",
      dateName: "설날",
      isHoliday: "Y",
      locdate: 20260218,
      seq: 3
    },

    // 3월
    {
      dateKind: "01",
      dateName: "삼일절",
      isHoliday: "Y",
      locdate: 20260301,
      seq: 1
    },
    // 5월
    {
      dateKind: "01",
      dateName: "어린이날",
      isHoliday: "Y",
      locdate: 20260505,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "부처님오신날",
      isHoliday: "Y",
      locdate: 20260524,
      seq: 1
    },
    // 6월
    {
      dateKind: "01",
      dateName: "현충일",
      isHoliday: "Y",
      locdate: 20260606,
      seq: 1
    },

    // 8월
    {
      dateKind: "01",
      dateName: "광복절",
      isHoliday: "Y",
      locdate: 20260815,
      seq: 1
    },
    // 9월 추석 연휴 (24~26일)
    {
      dateKind: "01",
      dateName: "추석",
      isHoliday: "Y",
      locdate: 20260924,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "추석",
      isHoliday: "Y",
      locdate: 20260925,
      seq: 2
    },
    {
      dateKind: "01",
      dateName: "추석",
      isHoliday: "Y",
      locdate: 20260926,
      seq: 3
    },
    // 10월
    {
      dateKind: "01",
      dateName: "개천절",
      isHoliday: "Y",
      locdate: 20261003,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "한글날",
      isHoliday: "Y",
      locdate: 20261009,
      seq: 1
    },
    // 12월
    {
      dateKind: "01",
      dateName: "기독탄신일",
      isHoliday: "Y",
      locdate: 20261225,
      seq: 1
    }
  ]
};
